import { render, staticRenderFns } from "./ProjectLogBook.vue?vue&type=template&id=5a119cfc&scoped=true&"
import script from "./ProjectLogBook.vue?vue&type=script&lang=ts&"
export * from "./ProjectLogBook.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectLogBook.vue?vue&type=style&index=0&id=5a119cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a119cfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VHover,VIcon,VRow,VSnackbar,VSpacer})
